var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"se-card",class:'se-card--' + this.width},[_c('div',{staticClass:"se-card__inner",style:([{backgroundImage: this.backgroundImg}, {backgroundColor: this.bgColor}])},[(_vm.hasBgImg)?_c('div',{staticClass:"se-card__img-overlay"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"se-card__content"},[_vm._t("default")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdcde640","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SnapshotCard.vue
// module id = null
// module chunks = 